import { createRootRoute, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import { ThemedToaster } from '@/components/ui/ThemedToaster';

export const Route = createRootRoute({
  component: () => (
    <>
      <Outlet />
      <ThemedToaster />
      {import.meta.env.DEV && <TanStackRouterDevtools />}
    </>
  ),
});
